import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle, Info, ShieldAlert } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Card, CardContent } from './card';
const VARIANT_STYLES = {
    danger: {
        card: 'border-red-200 bg-red-50',
        icon: ShieldAlert,
        iconBg: 'bg-red-500',
        text: 'text-red-700',
        title: 'text-red-800',
    },
    info: {
        card: 'border-blue-200 bg-blue-50',
        icon: Info,
        iconBg: 'bg-blue-500',
        text: 'text-blue-700',
        title: 'text-blue-800',
    },
    warning: {
        card: 'border-amber-200 bg-amber-50',
        icon: AlertTriangle,
        iconBg: 'bg-amber-500',
        text: 'text-amber-700',
        title: 'text-amber-800',
    },
};
export function InfoBanner({ className, description, title, variant = 'info' }) {
    const styles = VARIANT_STYLES[variant];
    const Icon = styles.icon;
    return (_jsx(Card, { className: cn(styles.card, className), children: _jsx(CardContent, { className: "pt-6", children: _jsxs("div", { className: "flex gap-3", children: [_jsx("div", { className: cn('mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full', styles.iconBg), children: _jsx(Icon, { className: "size-3 text-white" }) }), _jsxs("div", { children: [_jsx("p", { className: cn('mb-1 font-medium', styles.title), children: title }), _jsx("p", { className: cn('text-sm', styles.text), children: description })] })] }) }) }));
}
